import toast from 'react-hot-toast'

const TOAST_ID = 'lazy-load-failed'

/**
 * One sticky toast (same id, never stacked) when on-demand code can't download — usually a deploy since this tab
 * opened. Refresh is the person's choice, so nothing they are typing is lost without warning.
 */
export function showLazyLoadFailedToast() {
  toast(
    () => (
      <span className="flex items-center gap-3">
        <span>This part of Hayven couldn’t load. It may have just been updated.</span>
        <button
          type="button"
          className="shrink-0 font-semibold underline underline-offset-2"
          onClick={() => window.location.reload()}
        >
          Refresh
        </button>
      </span>
    ),
    { id: TOAST_ID, duration: Infinity }
  )
}
